import { message } from "ant-design-vue";
const { ...other } = message;
const Ywmessage= {
  ...other,
  name: "Ywmessage",
};

Ywmessage.install = function (Vue) {
  Vue.component(Ywmessage.name,message);
};

export default Ywmessage;